import { Form, Input } from "antd";
import React from "react";
import "../FormItemInput/FromItemInput.scss";

const { TextArea } = Input;

interface FormItemInputProps {
  name: string;
  placeholder?: string;
  label: string;
  rules:
    | { required: boolean; message?: string }
    | [{ required: boolean; message?: string }, { pattern: RegExp; message: string }];
  defaultValue?: string;
  disabled?: boolean;
  isSettingInput?: boolean;
  maxLength?: number;
}

const FormItemInput: React.FC<FormItemInputProps> = ({
  name,
  placeholder,
  rules,
  label,
  defaultValue,
  disabled,
  isSettingInput,
  maxLength,
}) => {
  return (
    <Form.Item
      className={`form-item__input ${isSettingInput ? "setting" : ""}`}
      name={name}
      label={label}
      rules={Array.isArray(rules) ? rules : [{ required: rules.required, message: rules.message }]}
    >
      <TextArea
        className={"input textarea"}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        maxLength={maxLength}
      />
    </Form.Item>
  );
};

export default FormItemInput;
